export default __webpack_public_path__ + "static/media/Agree_Terms.80aa185f.svg";